import React, {useMemo} from "react";
import {countries} from "@/lib/countries";

type CountryNameProps = {
    countryISO: string;
}

export const CountryName: React.FC<CountryNameProps> = ({countryISO}) => {
    const country = useMemo(() => {
        if (!countryISO) return null;
        return countries.find(c => c.countryCode === countryISO);
    }, [countryISO]);

    if (!countryISO) {
        return <span className="text-grey">N/A</span>;
    }

    if (!country) {
        return <span className="text-grey">{countryISO}</span>;
    }

    return (
        <span>
            {country.flag} {country.countryNameEn}
        </span>
    );
};
